import { TZDate } from '@date-fns/tz';

export const TIME_ZONE = 'America/New_York';
export const TUTORIAL_ID = '999999';
export const ZERO_DAY = new TZDate('2024-11-11T05:00:00.000Z', 'America/New_York');
export const TOTAL_TURNS = 5;
